import { Flex } from '@flex-design-system/fx';

import { ConsentRadioField } from './ConsentRadioField';
import {
  get_개인정보_수집_및_이용,
  get_민감정보,
  get_인재풀_활용_동의,
} from './constants';
import { TermsGroupContainer } from './TermsGroupContainer';

interface Props {
  customerName: string;
  requiredSensitiveInformation: boolean;
}

export function Terms({ customerName, requiredSensitiveInformation }: Props) {
  return (
    <Flex direction="column" css={{ gap: 40 }}>
      <TermsGroupContainer
        termGroup={get_개인정보_수집_및_이용({ customerName })}
      />
      {requiredSensitiveInformation ? (
        <ConsentRadioField
          name="agreedToSensitiveInformationTerms"
          termGroup={get_민감정보()}
        />
      ) : null}
      <ConsentRadioField
        name="hasTalentPoolConsent"
        termGroup={get_인재풀_활용_동의()}
      />
    </Flex>
  );
}
